import WsForm from './form.vue'

export default WsForm
